import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslations } from '@power-core/toolkit';
import { useAppContext } from '@/modules/app-context/use-app-context';
import { checkIfThereIsUnacceptedAccessesApi } from '../api/shared-documents.api';
import { useAuth } from '@power-core/toolkit';

export const useCheckIfThereIsUnacceptedAccesses = () => {
	const queryClient = useQueryClient();
	const { showToast } = useAppContext();
	const { auth } = useAuth();
	const t = useTranslations();

	const { data, isPending } = useQuery({
		queryKey: ['[GET]:CHECK_IF_THERE_IS_UNACCEPTED_ACCESSES'],
		queryFn: () =>
			checkIfThereIsUnacceptedAccessesApi().then((data) => {
				if (data.data) {
					showToast({
						message: t('T_SHARED_DOCUMENT_TOAST_MESSAGE'),
						variant: 'info',
					});
				}

				return data;
			}),
		refetchInterval: 5 * 60 * 1000,
		refetchOnMount: false,
		enabled: auth.status === 'authenticated',
	});

	const { mutateAsync } = useMutation({
		mutationFn: async (value: boolean) => {
			queryClient.setQueryData(['[GET]:CHECK_IF_THERE_IS_UNACCEPTED_ACCESSES'], { data: value });
		},
	});

	return {
		isUnacceptedAccess: data?.data,
		isPending,
		setIsUnacceptedAccesses: mutateAsync,
	};
};
